
const menu = require('../../../../../components/menu/menu')
const dtHandler = require('../../../../../components/dt/dt-handler')


export function start(detail, htmlDt, htmlFc) {

  const menuElem = menuBody[detail.id]

  for (let i = 0; i < menuElem.length; i++) {
    menuElem[i].start(detail, htmlDt, htmlFc)
  }

  detail.html = menuElem

  detail.act = 'show'
  menu.start(detail)

}


const menuBody = {

  trMenu: [

    {
      text: '',
      svg: 'eye',
      class: ``,
      dataDetail: ``,

      start: function (detail) {
        this.text = 'View/Edit'
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              { "dest":"item", "elem":"fullcont", "id":"item-fullcont", "act":"selectOne",  "entity":"item", "dbid": ${detail.dbid} }
           ]}'`

      }
    },

    {
      text: '',
      svg: 'docs',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));

        this.text = 'Report'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"fullcont", "entity":"inventory", "reportName":"inventory-item-one", "act":"printReport", "dbid":"${detail.dbid}", "item_unit_id":"${item_data.item_unit_id}"} 

        ]}'`

      }

    },

    {
      text: '',
      svg: 'history',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));

        this.text = 'History'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"fullcont", "entity":"inventory", "reportName":"inventory-item-history", "act":"printReport", "dbid":"${detail.dbid}"} 

        ]}'`

      }

    },

    {
      text: '',
      svg: 'update_file',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));
        //if exist one check
        this.class = ``
        this.text = `Update Selling Price`
        this.dataDetail = `data-detail='{
                            "click": [
                                {"dest":"ripple" },
                                {"dest":"menu", "act":"hide"},
                                {"dest":"item", "elem":"dt", "id":"item-dt", "act":"dialogUpdateSellingPrice", 
                                "dbid":"${detail.dbid}", "item_name":"${item_data.item_name}", "item_unit_id":"${item_data.item_unit_id}",
                                "item_unit_name":"${item_data.item_unit_name}" }  ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'add_lost',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        let td = detail.ev.target;
        let tr = td.parentNode;
        let item_data = JSON.parse(tr.getAttribute('data-item'));
        //if exist one check
        this.class = ``
        this.text = `Add Lost Qty`
        this.dataDetail = `data-detail='{
                            "click": [
                                {"dest":"ripple" },
                                {"dest":"menu", "act":"hide"},
                                {"dest":"item", "elem":"fullcontLost", "id":"itemLost-fullcont", "act":"prepareAdd", 
                                "dbid":"${detail.dbid}", "item_name":"${item_data.item_name}", "item_unit_id":"${item_data.item_unit_id}",
                                "item_unit_name":"${item_data.item_unit_name}" }  ]}'`
      }/**/
    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}
        ]}'`,

      start: function (detail) {

        this.text = 'Delete'
        this.dataDetail = `data-detail='{
                            "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"fullcont", "act":"deleteEntity", "entity":"item", "dbid":["${detail.dbid}"] } 
           ]}'`

      }
    },
  ],

  tableOptions: [
    
    {
      text: 'Inventory Update',
      svg: 'update',
      class: ``,
      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"},
                              {"dest":"inventoryUpdate", "elem":"fullcont", "id":"inventoryUpdate-fullcont", "act":"selectOne", "entity":"item"}
                          ]}'`,
      start: function () { }
    },

    { text: 'line', start: function () { } },

    {
      text: '',
      svg: 'expand',
      class: ``, //same name as the title test

      dataDetail: `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"},
                              {"dest":"item", "elem":"dt",  "act":"showAllItem" ,"entity":"item"} 

        ]}'`,


      start: function () {
        this.text = 'All Items'        //language.start('inProgress')     
      }
    },




    {
      text: '',
      svg: 'status_report',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Inventory Status'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"fullcont", "entity":"inventory", "reportName":"inventory-items-available", "act":"printReport"}

        ]}'`

      }

    },

    {
      text: '',
      svg: 'count_report',
      class: ``, //same name as the title test

      dataDetail: '',

      start: function (detail) {
        this.text = 'Inventory Count'        //language.start('inProgress')
        this.dataDetail = `data-detail='{
                          "click": [
                              {"dest":"ripple" },
                              {"dest":"menu", "act":"hide"}, 
                              {"dest":"item", "elem":"fullcont", "entity":"inventory", "reportName":"inventory-count", "act":"printReport"}

        ]}'`

      }

    },

    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``,
      dataDetail: ``,



      start: function (detail, htmlDt) {

        const ids = dtHandler.getTrChecked(htmlDt)

        //if exist one check
        if (ids.length > 0) {
          this.class = ``
          this.text = `Delete All (${ids.length})`
          this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"fullcont", "act":"deleteEntity", "entity":"item",  "dbid":[${ids}]} ]}'`
        } else {
          this.class = `disabled`
          this.text = `Delete All`
          this.dataDetail = ''
        }/*if*/

      }/**/
    },
  ],

  fullcontOptions: [

    {
      text: '',
      svg: 'edit',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {
        this.text = `Edit`
        this.dataDetail = `data-detail='{
                                   "click": [
                                      {"dest":"ripple" },
                                      {"dest":"menu", "act":"hide"},
                                      {"dest":"item", "elem":"fullcont",  "id":"item-fullcont", "act":"prepareEdit" }  ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'docs',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `Report`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"fullcont", "entity":"inventory", "reportName":"inventory-item-one", "act":"printReport"} ]}'`
      }/**/
    },

    {
      text: '',
      svg: 'history',
      class: ``, //same name as the title test
      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        //if exist one check
        this.class = ``
        this.text = `History`
        this.dataDetail = `data-detail='{
                                     "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"fullcont", "entity":"inventory", "reportName":"inventory-item-history", "act":"printReport"} ]}'`
      }/**/
    },


    { text: 'line', start: function () { } }, //////////////line

    {
      text: '',
      svg: 'delete',
      class: ``, //same name as the title test

      dataDetail: ``,

      start: function (detail, htmlDt, htmlFc) {

        const dbid = htmlFc.fullcontHTML.getAttribute('data-dbid')

        //if exist one check
        this.class = ``
        this.text = `Delete `
        this.dataDetail = `data-detail='{
                                    "click": [
                                        {"dest":"ripple" },
                                        {"dest":"menu", "act":"hide"},
                                        {"dest":"item", "elem":"fullcont", "act":"deleteEntity", "entity":"item",  "dbid":[${dbid}]} ]}'`

      }/**/
    },


  ],

}/*menuBody*/